
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/[category]",
      function () {
        return require("private-next-pages/courses/[category].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/courses/[category]"])
      });
    }
  